export const RESOLVE: 'TRANSLATION/RESOLVE' = 'TRANSLATION/RESOLVE';
export const RESOLVE_FAILURE: 'TRANSLATION/RESOLVE_FAILURE' = 'TRANSLATION/RESOLVE_FAILURE';
export const RESOLVE_SUCCESS: 'TRANSLATION/RESOLVE_SUCCESS' = 'TRANSLATION/RESOLVE_SUCCESS';
